import React from 'react';
import { SanityImage } from 'sanity-image';

import BlockBuilder from '@repo/ui-components/sanity/BlockBuilder';
import PageWrapper from '@repo/ui-components/page-wrapper';

const sanityBaseUrl = `https://cdn.sanity.io/images/${process.env.GATSBY_SANITY_PROJECT_ID}/${process.env.GATSBY_SANITY_DATASET}/`;

interface SanityMediaAsset {
  _id: string;
}

interface BackgroundImage {
  asset: SanityMediaAsset;
  hotspot: {
    x: number;
    y: number;
  };
  crop: {
    bottom: number;
    left: number;
    right: number;
    top: number;
  };
  alt?: string;
}

interface MarketingContentSection {
  _key: string;
  label: string;
  fullWidth?: boolean;
  desktopBackground: BackgroundImage;
  mobileBackground: BackgroundImage;
  content: {
    blocks: [any];
  };
}

interface MarketingContentSectionsProps {
  marketingContentSections: [MarketingContentSection];
  setStartSectionRef: (el: any, index: number) => void;
  getInternalLink: (link: any) => string;
}

const MarketingContentSections: React.FC<MarketingContentSectionsProps> = ({
  marketingContentSections,
  setStartSectionRef,
  getInternalLink,
}) => (
  <div className="custom-pdp-container scroll-smooth mt-2">
    {marketingContentSections?.map((section, index) => {
      const SectionNode = (
        <div
          key={section?._key}
          className="relative min-h-screen h-full pt-0 flex flex-col items-center justify-center"
        >
          <div
            ref={el => {
              setStartSectionRef(el, index);
            }}
          />
          {section?.desktopBackground?.asset?._id && (
            <SanityImage
              id={section.desktopBackground.asset._id}
              baseUrl={sanityBaseUrl}
              width={1440}
              className="absolute top-0 left-0 w-full h-full object-cover select-none z-[1] hidden lg:block"
              alt={section.desktopBackground.alt}
            />
          )}
          {section?.mobileBackground?.asset?._id && (
            <SanityImage
              id={section.mobileBackground.asset._id}
              baseUrl={sanityBaseUrl}
              width={1024}
              className="absolute top-0 left-0 w-full h-full object-cover select-none z-[1] lg:hidden"
              alt={section.mobileBackground.alt}
            />
          )}

          <div className="flex flex-col items-center justify-center w-full z-[2]">
            {section?.content?.blocks?.length > 0 && (
              <BlockBuilder
                blocks={section.content.blocks}
                getInternalLink={getInternalLink}
              />
            )}
          </div>
        </div>
      );
      // Some blocks are meant to be full width (0 x-padding)
      if (section.fullWidth) {
        return SectionNode;
      }
      return <PageWrapper key={section._key}>{SectionNode}</PageWrapper>;
    })}
  </div>
);

export default MarketingContentSections;
